import {BaseAnalyticsEvent} from "../../../../../infrastructure/models/analytics/base-analytics-event";
import {GAME_STATUSES} from "../../../../../core/app/consts";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {LIVE_STREAMING_MODULE} from "../live-streaming-widget.consts";

export class LiveStreamingDisplayEvent extends BaseAnalyticsEvent {
  gameId: Number;
  status: GAME_STATUSES;
  bookieId: Number;
  urlLink: String;
  stripType: LIVE_STREAMING_MODULE.STRIP_COLOR_MODE;

  constructor(params) {
    super('', 'display', 'live-streaming');

    this.gameId = params.gameId;
    this.status = params.status;
    this.bookieId = params.bookieId;
    this.urlLink = params.urlLink;
    this.stripType = params.stripType;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.bookieId = this.bookieId;
    properties.urlLink = this.urlLink;
    properties.stripType = this.stripType;

    return properties;
  }
}